"use client";

import { createContext, useContext, useState, useEffect } from "react";
import { useSession } from "next-auth/react";

const RegisteredUserContext = createContext();

export const RegisteredUserProvider = ({ children }) => {
  const [isRegistered, setIsRegistered] = useState(false);
  const { data, status } = useSession();

  async function registeredUser(email) {
    const res = await fetch("/api/author", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (!res.ok) return null;
    return await res.json();
  }

  const markAsRegistered = () => {
    setIsRegistered(true);
    localStorage.setItem("isRegistered", "true");
  };

  const clearRegistration = () => {
    setIsRegistered(false);
    localStorage.removeItem("isRegistered");
  };

  useEffect(() => {
    const checkIfRegistered = async () => {
      if (status !== "authenticated") {
        return;
      }

      const email = data?.user?.email;
      if (!email) {
        return;
      }

      try {
        const author = await registeredUser(email);
        if (author) {
          markAsRegistered();
        } else {
          clearRegistration();
        }
      } catch (err) {
        clearRegistration();
      }
    };

    checkIfRegistered();
  }, [status, data?.user?.email]);

  return (
    <RegisteredUserContext.Provider
      value={{ isRegistered, markAsRegistered, clearRegistration }}
    >
      {children}
    </RegisteredUserContext.Provider>
  );
};

export const useRegisteredUser = () => useContext(RegisteredUserContext);
